import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Savings from './Savings';
import Banner from './Banner';
import { IoDiamondSharp } from "react-icons/io5";
import './Range.scss';

function Range() {
  const navigate = useNavigate(); // Hook to get the navigate function

  const handleBackClick = () => {
    navigate('/'); // Navigate to another route
  };

  return (
    <div className="main-container">
      <div className="slider-indicator">
        <button className="nav-button left" onClick={handleBackClick}>{'<'}</button>
        <div className="icon-circle">
          <IoDiamondSharp className='icon' />
        </div>
        <button className="nav-button right">{'....'}</button>
      </div>
        
      <Savings />
      <Banner />
    </div>
  );
}

export default Range;
